import { motion } from 'framer-motion'
import React, { useEffect, useRef, useState } from 'react'
import x from '../../assets/icons/close.svg'
import lock from '../../assets/icons/lock.svg'
import eye from '../../assets/icons/eyeBlack.svg'
import eyel from '../../assets/icons/closedEye.svg'
import changeUsePassword from '../../apis/changeUsePassword'

const ChangePassword = ({ active, close, user }) => {
  console.log(user)
  const popupref = useRef(null)
  const [loading, setLoading] = useState(false)
  const [showCurrent, setshowCurrent] = useState(false)
  const [showNew, setshowNew] = useState(false)
  const [showConfirmation, setshowConfirmation] = useState(false)
  const [error, setError] = useState(false)
  const [userData, setUserData] = useState({
    id: user.id,
    currentPassword: '',
    newPassword: '',
    newPassword_confirmation: '',
  })

  const handleInputChange = (e) => {
    setError('')
    const { name, value } = e.target
    setUserData((prevData) => ({ ...prevData, [name]: value }))
  }

  const handleChangePasswod = async (e) => {
    e.preventDefault()

    if (userData.newPassword !== userData.newPassword_confirmation) {
      setError('passwords does not match')
      return
    }
    try {
      setLoading(true)
      await changeUsePassword(userData)
      close()
    } catch (error) {
      console.log(error)
      setError(error.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [popupref, close])

  useEffect(() => {
    if (active) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [active])
  return (
    <motion.div
      className=" fixed inset-0 bg-overlay/30 w-screen  z-40 h-screen grid place-items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        ref={popupref}
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
        className=" w-1/3 min-h-10 overflow-hidden bg-white rounded-lg flex flex-col justify-center items-center"
      >
        <div className=" w-full px-8 py-5 flex flex-col gap-8 ">
          <div className="flex border-b-[1px] pb-4 justify-between border-b-darkBlue w-full">
            <div>Change Password</div>
            <img src={x} onClick={close} className=" cursor-pointer" alt="" />
          </div>
          <div className=" items-center flex flex-col w-full gap-2 justify-center">
            <div className=" text-darkBlue w-full">
              {`${user.first_name} ${user.last_name}`}
            </div>

            <form
              onSubmit={handleChangePasswod}
              className=" w-full flex flex-col gap-5"
            >
              <div className=" w-full flex flex-col gap-2">
                <label className=" text-darkBlue">Admin Password</label>
                <div className="w-full rounded-xl p-3 gap-2 border-[1px] border-blueButton flex ">
                  <img src={lock} alt="" className="w-5" />
                  <input
                    name="currentPassword"
                    onChange={handleInputChange}
                    value={userData.currentPassword}
                    type={showCurrent ? 'text' : 'password'}
                    placeholder="Admin Password"
                    className=" w-10/12 focus:outline-none"
                    required
                  />
                  <img
                    src={showCurrent ? eye : eyel}
                    onClick={() => setshowCurrent(!showCurrent)}
                    alt=""
                    className="w-5 cursor-pointer"
                  />
                </div>
              </div>
              <div className=" w-full flex flex-col gap-2">
                <label className=" text-darkBlue">New Password</label>
                <div className="w-full rounded-xl p-3 gap-2 border-[1px] border-blueButton flex ">
                  <img src={lock} alt="" className="w-5" />
                  <input
                    name="newPassword"
                    onChange={handleInputChange}
                    value={userData.newPassword}
                    type={showNew ? 'text' : 'password'}
                    placeholder="New Password"
                    className=" w-10/12 focus:outline-none"
                    required
                  />
                  <img
                    src={showNew ? eye : eyel}
                    onClick={() => setshowNew(!showNew)}
                    alt=""
                    className="w-5 cursor-pointer"
                  />
                </div>
              </div>
              <div className=" w-full flex flex-col gap-2">
                <label className=" text-darkBlue">
                  New Password Confirmation
                </label>
                <div className="w-full rounded-xl p-3 gap-2 border-[1px] border-blueButton flex ">
                  <img src={lock} alt="" className="w-5" />
                  <input
                    name="newPassword_confirmation"
                    onChange={handleInputChange}
                    value={userData.newPassword_confirmation}
                    type={showConfirmation ? 'text' : 'password'}
                    placeholder="New Password Confirmation"
                    className=" w-10/12 focus:outline-none"
                    required
                  />
                  <img
                    src={showConfirmation ? eye : eyel}
                    onClick={() => setshowConfirmation(!showConfirmation)}
                    alt=""
                    className="w-5 cursor-pointer"
                  />
                </div>
              </div>
              {error && (
                <div className=" w-full flex justify-center items-center  p-2">
                  <div className=" bg-red/25 p-1 text-red rounded">{error}</div>
                </div>
              )}
              <button
                disabled={loading || error}
                className="disabled:bg-darkBlue/50 rounded-lg bg-blueButton text-white text-center p-4 w-full"
              >
                Change Password
              </button>
            </form>
          </div>
        </div>
      </motion.div>
    </motion.div>
  )
}

export default ChangePassword
